import * as api from "~/apps/shared/apis/passwordReset";
import { apiCall } from "~/lib/redux/api";
import { PasswordResetActions } from "~/apps/shared/actions/consts";

export function sendResetEmail(req) {
  return apiCall({
    actions: [
      PasswordResetActions.LOAD_REQUEST,
      [PasswordResetActions.LOAD_SUCCESS, PasswordResetActions.LOAD_SEND_SUCCESS],
      PasswordResetActions.LOAD_ERROR,
    ],
    fn: () => api.sendResetEmail(req),
  });
}

export function validateResetCode(code) {
  return apiCall({
    actions: [
      PasswordResetActions.LOAD_REQUEST,
      PasswordResetActions.LOAD_SUCCESS,
      PasswordResetActions.LOAD_ERROR,
    ],
    fn: () => api.validateResetCode(code),
  });
}

export function setNewPassword(code, req) {
  return apiCall({
    actions: [
      PasswordResetActions.LOAD_REQUEST,
      [PasswordResetActions.LOAD_SUCCESS, PasswordResetActions.LOAD_SEND_SUCCESS],
      PasswordResetActions.LOAD_ERROR,
    ],
    fn: () => api.setNewPassword(code, req),
  });
}
